// eslint-disable-next-line import/no-unresolved
// eslint-disable-next-line import/no-unresolved
const detail = require('base/product/detail');
const lozad = require('lozad');
const baseDetail = require('onestic-base/product/baseDetail');
const scrollAnimate = require('onestic-base/components/scrollAnimate');
const slickSlider = require('onestic-base/components/slider');
const constants = require('onestic-base/constants');
const formLabelHelpers = require('onestic-base/components/form');
const storeLocator = require('onestic-base/storeLocator/storeLocator');
const utils = require('onestic-base/utils');
const createTrapFocus = require('onestic-base/components/accessibility/focusTrap');

/**
 * Trigger lozad
 */
function triggerLozad() {
    const observer = lozad('.lozad', {
        enableAutoReload: true,
    });
    observer.observe();
}


function getProductPrice($component) {
    let price = $component.find('.prices .sales .value').attr('content');
    if (!price) {
        const priceComponents = $component.find('.prices .price .value');
        if (priceComponents.length > 0) {
            const priceComponent = priceComponents[0];
            if (priceComponent) {
                price = $(priceComponent).attr('content');
            }
        }
    }

    return price;
}
function getProductPriceFormat($component) {
    const symbol = $('#sequraConfig').attr('data-currencysymbol');
    let price = $component.find('.prices .sales .value:visible').length ? $component.find('.prices .sales .value:visible').text() : null;
    if (!price) {
        const priceComponents = $component.find('.prices .price .value');
        if (priceComponents.length > 0) {
            const priceComponent = priceComponents[0];
            if (priceComponent) {
                price = $(priceComponent).text();
            }
        }
    }

    return price ? price.trim().replace(symbol, '') : null;
}


function updateShowStockButton() {
    const pdpInfoContainer = $('.pdp-info-wrapper');
    const countPdpAttributes = pdpInfoContainer.find('.attributes-pdp-wrapper').length;
    const showStock = $('#show-stock');

    if (countPdpAttributes) {
        const countPdpAttributesSelected = pdpInfoContainer.find('.attributes-pdp-wrapper .attributeLink.selected:not(.outofstock)').length;

        if (countPdpAttributes === countPdpAttributesSelected) {
            showStock.attr('disabled', false);
            showStock.removeClass('disabled');
        } else {
            showStock.attr('disabled', true);
            showStock.addClass('disabled');
        }
    } else {
        showStock.attr('disabled', false);
        showStock.removeClass('disabled');
    }
}

/**
 * Load Store Availability Modal
 */
function loadAvailabilityStoreModal() {
    const pid = $('.product-id').text();
    const componentStoreAvailability = $('#show-stock');
    if (componentStoreAvailability.length && pid) {
        let url = componentStoreAvailability.data('stockurl');
        if (url) {
            url += `?productId=${pid}&showAvailable=true`;
            $.ajax({
                url,
                type: 'get',
                success: (response) => {
                    if (response && response.storesResultsHtml) {
                        const showStock = $('body');

                        $('#store-inventory-modal').remove();

                        showStock.append(response.storesResultsHtml);
                        updateShowStockButton();
                        triggerLozad();
                        formLabelHelpers.inputFocus();
                        storeLocator.search();
                        storeLocator.changeRadius();
                        storeLocator.selectStore();
                        storeLocator.updateSelectStoreButton();
                    }
                },
            });
        }
    }
}

function preOrNextNotFound(productId) {
    let found = 0;
    let index = 0;
    let arr;
    let arrPrev;
    let arrNext;
    while (found === 0) {
        arr = sessionStorage.getItem(`productsPrevNext${index}`);

        if (!arr) {
            found = -1;
            break;
        }

        if (index > 0) {
            const indexPrev = index - 1;
            arrPrev = sessionStorage.getItem(`productsPrevNext${indexPrev}`);
        }

        if (arr.indexOf(productId) !== -1) {
            found = 1;
        }

        index += 1;
        arrNext = sessionStorage.getItem(`productsPrevNext${index}`);
    }

    if (arr) {
        arr = arr.trim();
    }

    if (arr && arrPrev && arr.indexOf(arrPrev) === -1) {
        arr = `${arrPrev.trim()};${arr}`;
    }
    if (arr && arrNext && arr.indexOf(arrNext) === -1) {
        arr += `;${arrNext.trim()}`;
    }

    return {
        found,
        arr,
    };
}

/**
 * Registering on change event on quantity selector. If store has been selected, exist function,
 * otherwise proceed to update attributes.
 */
function availability() {
    // eslint-disable-next-line func-names
    $(document).on('change', '.quantity', function (e) {
        e.preventDefault();

        const searchPID = $(this)
            .closest('.product-detail')
            .attr('data-pid');
        const selectorPrefix = `.product-detail[data-pid="${searchPID}"]`;

        if ($(`${selectorPrefix} .selected-store-with-inventory`).is(':visible')) {
            return;
        }

        let $productContainer = $(this).closest('.product-detail');
        if (!$productContainer.length) {
            $productContainer = $(this)
                .closest('.modal-content')
                .find('.product-quickview');
        }

        if ($('.bundle-items', $productContainer).length === 0) {
            baseDetail.attributeSelect(
                $(e.currentTarget)
                    .find('option:selected')
                    .data('url'),
                $productContainer,
            );
        }
    });
}

const updatePDPSocialIcons = (data) => {
    $('#socialContainer').replaceWith(data.product.socialIconsHtml);
    const socialIconsLink = $('.social-icons-link');
    const iconsListContainer = $('.social-wrapper');
    const shareProductId = iconsListContainer.data('shareid');
    const attributeSelected = $('.attributeLink.selected');
    const productVariationhref = attributeSelected.attr('href');
    const productVariationurl = !productVariationhref
        ? attributeSelected.attr('value')
        : productVariationhref;

    if (productVariationurl) {
        const productVariationShowUrl = productVariationurl.replace('Product-Variation', 'Product-Show');

        if (socialIconsLink.length > 1) {
            socialIconsLink.eq(0);
        }

        iconsListContainer.find('li a').each((indx, value) => {
            const $value = $(value);
            const newUrl = $value.attr('href').replace(shareProductId, productVariationShowUrl);

            $value.attr('href', newUrl);
        });
    }
};

function updateAttribute() {
    $('body').on('product:afterAttributeSelect', (e, response) => {
        e.stopImmediatePropagation();

        const { product } = response.data;
        const productID = product.id;
        const { prev, next } = utils.getSliderLabels();

        if (!response.container.hasClass('grid-quickshopping')) {
            if ($('.product-detail > .bundle-items').length) {
                response.container.attr('data-pid', product.id);
                response.container.find('.product-id').text(productID);
            // TODO: Revisar estos condicionales: $('.product-set-detail').eq(0) es true
            // cuando no se esta en el set, este código se ejecuta en master o Group var..
            } else if ($('.product-set-detail').eq(0)) {
                // update pid of PDP when size variation is auto-selected
                response.container.attr('data-pid', productID);
                response.container.find('.product-id').text(productID);

                const productName = response.container.find('h1');
                if (product
                    && product.productName
                    && product.productName !== productName.text()) {
                    productName.text(product.productName);
                    if ($('.set-items').length <= 0) {
                        $('.prod-name .prod-name, .breadcrumb-item:last-of-type span').text(product.productName);
                    } else {
                        response.container.find('.primary-link').attr('href', product.variationUrl);
                    }
                }

                const productDescription = response.container.find('.description-block .content');
                if (product
                    && product.shortDescription
                    && product.shortDescription !== productDescription.text()) {
                    productDescription.html(product.shortDescription);
                }

                $.ajax({
                    url: product && product.variationUrl
                        ? product.variationUrl
                        : product.selectedProductUrl,
                    type: 'GET',
                    success: (data) => {
                        const recommendationsContainer = '.recommendations .recommended-product-carousel .product-carousel';
                        const recommendationsTitle = $('.recommendations .recommended-product-carousel .text-block');
                        const recommendationsData = $(data).find(recommendationsContainer);

                        if (recommendationsData.length) {
                            recommendationsTitle.show();
                            $(recommendationsContainer).replaceWith(recommendationsData);

                            slickSlider.methods.useCustomizableSlick(
                                recommendationsContainer,
                                true,
                                `<button type="button" class="icon-left-arrow-line next no-btn" aria-label="${prev}"></button>`,
                                `<button type="button" class="icon-right-arrow-line prev no-btn" aria-label="${next}"></button>`,
                                4,
                                {
                                    dots: false,
                                    arrows: true,
                                    infinite: false,
                                    adaptiveHeight: true,
                                    responsive: [
                                        {
                                            breakpoint: constants.viewport_bootstrap.md,
                                            settings: {
                                                slidesToShow: 2,
                                                slidesToScroll: 2,
                                                arrows: true,
                                                dots: false,
                                            },
                                        },
                                        {
                                            breakpoint: constants.viewport_bootstrap.lg,
                                            settings: {
                                                slidesToShow: 3,
                                                slidesToScroll: 3,
                                                arrows: true,
                                                dots: false,
                                            },
                                        },
                                    ],
                                },
                            );
                        }

                        if (window.dataLayer) {
                            $('body').trigger('datalayer:updateGrid');
                        }
                    },
                });
            } else {
                $('.product-id').text(productID);
                $('.product-detail:not(".bundle-item")').data('pid', response.data.product.id);
            }

            const zoomCarouselContainer = response.container.find('.zoomCarousel');
            if (zoomCarouselContainer.length) {
                zoomCarouselContainer.attr('id', `carouselProdViewModal-${response.data.product.id}`);
                zoomCarouselContainer.attr('aria-labelledby', `carouselProdViewModal-${response.data.product.id}`);
            }

            if ($('.attributeLink.selected').length) {
                updatePDPSocialIcons(response.data);
            }

            loadAvailabilityStoreModal();
            this.renderSequraWidget();
        }
    });
}

const checkCTABarPosition = () => {
    const startScrollElement = $('.prices-add-to-cart-actions');
    const productStructurePosition = parseInt(startScrollElement.offset().top, 10)
                                    + parseInt(startScrollElement.innerHeight(), 10);
    let isScrollUnderElement = false;

    if (document.documentElement.scrollTop > productStructurePosition) {
        isScrollUnderElement = true;
    }

    return isScrollUnderElement;
};

const applyCtaScroll = (ctabarContainer, chatContainer, chatContainerBottom) => {
    const isScrollUnderElement = checkCTABarPosition();

    if (isScrollUnderElement) {
        ctabarContainer.slideDown(() => {
            if (chatContainer.length) {
                const ctaBarHeight = ctabarContainer.height() + 80;
                chatContainer.css('bottom', `${ctaBarHeight}px`);
            }
        }).css('display', 'flex');
    } else {
        const attributeSelected = $('.attribute-selected.active');
        if (attributeSelected.length) {
            attributeSelected.trigger('click');
        }
        ctabarContainer.slideUp(() => {
            if (chatContainer.length) {
                chatContainer.css('bottom', chatContainerBottom);
            }
        });
    }
};

const firstVariationClickScroll = () => {
    const firstVar = $('.first-variation');

    if (firstVar.length) {
        const docBody = $(document.body);

        docBody.on('click', '.first-variation', (e) => {
            const varAttr = $(e.currentTarget).data('attr');
            const headerHeight = parseInt($('header').height(), 10);

            scrollAnimate($(`.attribute-wrapper[data-attr="${varAttr}"]`), headerHeight);
        });
    }
};

const addToCartProcess = () => {
    const docBody = $(document.body);

    docBody.on('click', '.add-to-cart-process', (e) => {
        const currentTarget = $(e.currentTarget);

        // only open cart process with more than 1 variation
        if (!currentTarget.hasClass('trigger-add-to-cart')) {
            currentTarget.parents('.attribute-product').find('.variation-selection').removeClass('down');
        } else {
            const buttonAddToCart = $('.prices-add-to-cart-actions .add-to-cart');
            if (!buttonAddToCart.is(':disabled')) {
                buttonAddToCart.trigger('click');
            }
        }
    });
};

const ctaBarAttributes = () => {
    const html = $('html');
    const overlay = $('.attribute-overlay');
    const docBody = $(document.body);
    const ctabarContainer = $('.ctabar-product');
    const chatContainer = $('#zdButton') || $('#livechat-wrapper');
    docBody.on('click', '.attribute-selected', (e) => {
        const thisTarget = $(e.currentTarget);
        const thisOptions = thisTarget.siblings('.attribute-options');
        const thisIcon = thisTarget.find('.icon-down-arrow-line');
        $('.attribute-selected').not(thisTarget).removeClass('active');
        thisTarget.toggleClass('active');
        $('.attribute-options').not(thisOptions).css('z-index', -1).slideUp();
        $('.attribute-wrapper .icon-down-arrow-line').not(thisIcon).removeClass('open');
        thisOptions.css('z-index', 100).slideToggle(() => {
            if (chatContainer.length && thisTarget.hasClass('active')) {
                let ctaBarHeight = ctabarContainer.height() + $('.attribute-options').height() + 30;
                if (window.innerWidth < constants.viewport_bootstrap.xls) {
                    ctaBarHeight = $('.attribute-options').height() + 30;
                }
                chatContainer.css('bottom', `${ctaBarHeight}px`);
            } else {
                let ctaBarHeight = ctabarContainer.height();
                if (window.innerWidth < constants.viewport_bootstrap.xls) {
                    ctaBarHeight = ctabarContainer.height() + 30;
                }
                chatContainer.css('bottom', `${ctaBarHeight}px`);
            }
        });
        if (window.innerWidth < constants.viewport_bootstrap.xls) {
            overlay.fadeIn();
            html.css('overflow', 'hidden');
        }
        thisIcon.toggleClass('open');
    });

    docBody.on('click', '.attribute-overlay', (e) => {
        e.stopPropagation();
        e.preventDefault();
        $('.attribute-selected.active').trigger('click');
        if (window.innerWidth < constants.viewport_bootstrap.xls) {
            overlay.fadeOut();
            html.css('overflow', 'visible');
        }
    });
};


module.exports = {
    availability,
    updateAttributesAndDetails: detail.updateAttributesAndDetails,
    showSpinner: detail.showSpinner,
    updateAttribute,
    updateAddToCart: detail.updateAddToCart,
    updateAvailability: detail.updateAvailability,
    // eslint-disable-next-line func-names
    sizeChart: function () {
        const docBody = $(document.body);
        const prodSizeChart = $('.size-chart-collapsible');

        docBody.on('click', '.size-chart-link', (e) => {
            e.preventDefault();
            const url = $(e.currentTarget).attr('href');
            if (prodSizeChart.is(':empty')) {
                $.ajax({
                    url: url,
                    type: 'get',
                    dataType: 'json',
                    success: (data) => {
                        prodSizeChart.append(data.content);
                    },
                });
            }
            prodSizeChart.toggleClass('active');
        });

        docBody.on('click touchstart', (e) => {
            if ($('.size-chart').has(e.currentTarget).length <= 0) {
                prodSizeChart.removeClass('active');
            }
        });
    },

    copyProductLink() {
        const docBody = $(document.body);
        docBody.on('click', '#fa-link', (event) => {
            event.preventDefault();
            const copyLinkMessage = $('.copy-link-message').clone();
            const shareUrlValue = $(event.currentTarget).parent().find('#shareProductUrl').attr('data-url');

            if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
                navigator.clipboard.writeText(shareUrlValue);
            } else {
                const $temp = $('<input>');
                docBody.append($temp);
                $temp.val(shareUrlValue).select();
                document.execCommand('copy');
                $temp.remove();
            }
            docBody.append(copyLinkMessage);
            const newMessage = docBody.find('> .copy-link-message');
            newMessage.removeClass('d-none');
            setTimeout(() => {
                newMessage.addClass('d-none');
                newMessage.remove();
            }, 3000);
        });
    },

    focusChooseBonusProductModal: baseDetail.focusChooseBonusProductModal(),
    descriptionBlock: baseDetail.descriptionBlock(),
    ctaBarScroll() {
        const docBody = $(document.body);

        let ctabarContainer = $('.ctabar-product');
        const chatContainer = $('#zdButton') || $('#livechat-wrapper');
        const chatContainerBottom = chatContainer.css('bottom');

        applyCtaScroll(ctabarContainer, chatContainer, chatContainerBottom);

        $(window).scroll(() => {
            if (window.outerWidth >= constants.viewport_bootstrap.lg) {
                if ($('.ctabar-product') !== ctabarContainer) {
                    ctabarContainer = $('.ctabar-product');
                }
                applyCtaScroll(ctabarContainer, chatContainer, chatContainerBottom);
            }
        });

        docBody.on('click', '.view-details', (e) => {
            e.preventDefault();
            // eslint-disable-next-line no-unused-expressions
            const header = $('header').height();
            $('html, body').animate({
                scrollTop: $('#productDetails').offset().top - header,
            }, 500);
        });
    },
    ctaBarEvents() {
        if (window.outerWidth <= constants.viewport_bootstrap.md) {
            firstVariationClickScroll();
            addToCartProcess();
        }
        ctaBarAttributes();
    },
    moveSocialModal() {
        const socialModal = $('.social-container');

        if (socialModal.length) {
            $(document.body).append(socialModal);

            $(document.body).on('click', '.social-icons-link', (e) => {
                e.preventDefault();
                e.stopPropagation();
                socialModal.data('trigger', e.currentTarget);
                socialModal.modal('show');
            });

            socialModal.off('shown.bs.modal.a11y').on('shown.bs.modal.a11y', () => {
                const releaseFocus = createTrapFocus.trapFocus(socialModal, () => {
                    socialModal.modal('hide');
                });
                socialModal.data('releaseFocus', releaseFocus);
            });

            socialModal.off('hidden.bs.modal.a11y').on('hidden.bs.modal.a11y', () => {
                const releaseFocus = socialModal.data('releaseFocus');
                if (typeof releaseFocus === 'function') {
                    releaseFocus();
                }
                const trigger = socialModal.data('trigger');
                if (trigger && typeof trigger.focus === 'function') {
                    trigger.focus();
                }
            });
        }
    },
    imageZoom: baseDetail.imageZoom(constants),

    loadPrevNext() {
        const prevNextEnabled = $('#prevNextEnabled').val();
        if (prevNextEnabled && prevNextEnabled !== 'false') {
            const $setProducts = $('body').find('.set-item');
            const pid = $setProducts.length > 0 ? $($('.product-id')[0]).text() : $('.product-id').text();
            const prevOrNext = preOrNextNotFound(pid);
            if (prevOrNext.found !== -1) {
                const data = {
                    pid,
                    arr: prevOrNext.arr,
                };
                $.ajax({
                    url: $('#prevNextURL').val(),
                    type: 'get',
                    data,
                    dataType: 'json',
                    success: (response) => {
                        const component = $('.row-product-info').length > 0 ? $($('.row-product-info')[0]) : $('.row-product-info');
                        if (component) {
                            component.prepend(response.template);
                        }
                    },
                });
            }
        }
    },

    showMoreReviews() {
        const docBody = $(document.body);
        docBody.on('click', '#showmoreReviews', (e) => {
            e.preventDefault();
            const components = $("div[class^='review-block_']");
            if (components.length > 1) {
                components.each((index, component) => {
                    let componentShow = false;
                    if (!$(component).is(':visible') && !componentShow) {
                        componentShow = true;
                        $(component).show();
                        if (index === components.length - 1) {
                            $('#showmoreReviews').hide();
                            $('#showlessReviews').show();
                        }
                    }
                });
            }
        });

        docBody.on('click', '#showlessReviews', (e) => {
            e.preventDefault();
            const components = $("div[class^='review-block_']");
            if (components.length > 1) {
                for (let index = components.length - 1; index > 0; index -= 1) {
                    const component = components[index];
                    if ($(component).is(':visible')) {
                        $(component).hide();
                        $('#showmoreReviews').show();
                        if (index === 1) {
                            $('#showlessReviews').hide();
                        }
                    }
                }
            }
        });
    },
    loadAvailabilityStoreModal,
    hideBuyProduct() {
        $('body').on('click', '.hide-buyProduct', () => {
            $('.hide-buyProduct > .text-show').toggle();
            $('.hide-buyProduct > .text-hidden').toggle();

            $('.ctabar-product').toggleClass('compareDown');
        });
    },
    goToSetFirstOption() {
        const docBody = $(document.body);
        docBody.on('click', '.go-to-first-option', () => {
            scrollAnimate($('#productDetails'), $('header').height());
        });
    },

    renderSequraWidget() {
        // eslint-disable-next-line no-undef
        if (typeof sequraURLLoad !== 'undefined') {
            // eslint-disable-next-line global-require, import/no-unresolved
            const sequraWidget = require('sequra/product/sequraWidget');
            const $setProducts = $('body').find('.set-item');
            if (!$setProducts.length) {
                const $component = $('.product-detail');
                const price = getProductPrice($component);
                const formatPrice = getProductPriceFormat($component);
                const quantitySelector = $component.find('.quantity-select option:selected');
                const quantity = quantitySelector.length ? quantitySelector.val() : 1;
                if (price) {
                    sequraWidget.renderSequraWidget(price, quantity, $('.sequra-widget-component'), formatPrice);
                }
            } else {
                let totalPrice = 0;
                let formatPrice;
                $setProducts.each((_index, component) => {
                    const price = getProductPrice($(component));
                    formatPrice = getProductPriceFormat($(component));
                    const quantitySelector = $(component).find('.quantity-select option:selected');
                    const quantity = quantitySelector.val();
                    totalPrice += (quantity * price);
                    const inputWidget = $(component).find('.row.cart-and-ipay');
                    if (price) {
                        sequraWidget.renderSequraWidget(price, quantity, inputWidget, formatPrice);
                    }
                });
                const quantity = 1;
                if (totalPrice) {
                    sequraWidget.renderSequraWidget(totalPrice, quantity, $('.prices-add-to-cart-actions'), formatPrice);
                }
            }
        }
    },

    loadFuturePromotions() {
        const url = $('#futurePricePromotions').length ? $('#futurePricePromotions').val() : null;
        if (url) {
            const $component = $('.product-detail');
            const price = getProductPrice($component);
            const pid = $('.product-id').length && $('.product-id').text() ? $('.product-id').text().trim() : null;
            if (pid) {
                const data = {
                    productPrice: price,
                    pid: pid,
                };
                $.ajax({
                    url,
                    type: 'get',
                    data,
                    success: (response) => {
                        if (response.template) {
                            const pricesWrapper = $('.prices');
                            pricesWrapper.addClass('d-flex');
                            pricesWrapper.append(response.template);
                        }
                    },

                });
            }
        }
    },

    displayFlashSales() {
        // Update Flash Sales
        const flashSalesComponent = $('.flash-sales');
        if (flashSalesComponent.length) {
            // eslint-disable-next-line global-require, import/no-unresolved, import/extensions
            const flashSales = require('onestic-base/product/components/flashSales');
            flashSales.showTimer();
        }
    },
};
